"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  InputField: true
};
exports.default = exports.InputField = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _FormField = require("../FormField/_FormField");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _normalizeDoubleByteToStandard = require("../utils/normalizeDoubleByteToStandard");
var _isFunction = require("../utils/isFunction");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _useOverflowDetector = require("../utils/useOverflowDetector");
var _CharacterCounter = require("./_CharacterCounter");
var _InputField = require("./InputField.types");
Object.keys(_InputField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _InputField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InputField[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * **InputField** is used to gather input from a user. It emits an `<input>` element.
 *
 * > This component is designed to replace all usages of **FormGroup**, **InputGroup**,
 * **FormControl** and **ControlLabel**.
 */
const InputField = exports.InputField = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  var _a;
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(InputField, _props)) : _props;
  const {
      characterCounter,
      decorators = {},
      disabled,
      disableInternalValueStateMgmt,
      inputDescribedby,
      inputProps,
      inputRef,
      inputType = 'text',
      label,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      readOnly,
      required,
      value = '',
      enableUnicodeNormalization,
      unicodeNormalizationForm = 'NFC',
      disableInternalHandleChange = false
    } = props,
    otherProps = __rest(props, ["characterCounter", "decorators", "disabled", "disableInternalValueStateMgmt", "inputDescribedby", "inputProps", "inputRef", "inputType", "label", "onBlur", "onChange", "onFocus", "placeholder", "readOnly", "required", "value", "enableUnicodeNormalization", "unicodeNormalizationForm", "disableInternalHandleChange"]);
  const _b = characterCounter || {},
    {
      characterLimit,
      allowEntryOverCharacterLimit,
      onCharacterLimitStateChange,
      localizedText
    } = _b,
    otherCharacterCounterProps = __rest(_b, ["characterLimit", "allowEntryOverCharacterLimit", "onCharacterLimitStateChange", "localizedText"]);
  const classnames = _bind.default.bind({});
  const [limitExceeded, setLimitExceeded] = (0, _react.useState)(false);
  const [inputValue, setInputValue] = (0, _react.useState)(value);
  const charCountDecoratorId = (0, _useUniqueId.default)();
  const internalInputRef = (0, _react.useRef)(null);
  const mergedInputRef = (0, _reactMergeRefs.default)([internalInputRef, inputRef]);
  const {
    checkOverflow,
    hasOverflow
  } = (0, _useOverflowDetector.useOverflowDetector)(internalInputRef, [inputValue]);
  let inputId = (0, _useUniqueId.default)();
  if (inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) inputId = inputProps.id;
  const handleTextSizeLimit = text => {
    const inputValueLength = (text === null || text === void 0 ? void 0 : text.length) || 0;
    let validatedText = text;
    if (characterLimit && inputValueLength > characterLimit) {
      if (!allowEntryOverCharacterLimit) {
        validatedText = text.slice(0, characterLimit);
        setLimitExceeded(false);
      } else {
        setLimitExceeded(true);
      }
    } else {
      setLimitExceeded(false);
    }
    return validatedText;
  };
  (0, _react.useEffect)(() => {
    setInputValue(handleTextSizeLimit(value));
  }, [value]);
  (0, _react.useEffect)(() => {
    if ((0, _isFunction.isFunction)(onCharacterLimitStateChange)) {
      onCharacterLimitStateChange(limitExceeded);
    }
  }, [limitExceeded]);
  (0, _react.useEffect)(() => {
    if (inputType !== 'number') {
      return undefined;
    }
    const handleWheel = e => e.preventDefault();
    const input = internalInputRef.current;
    input === null || input === void 0 ? void 0 : input.addEventListener('wheel', handleWheel, {
      passive: false
    });
    return () => {
      input === null || input === void 0 ? void 0 : input.removeEventListener('wheel', handleWheel);
    };
  }, [internalInputRef, inputType]);
  const handleBlur = e => {
    if ((0, _isFunction.isFunction)(onBlur)) {
      onBlur(e);
    }
  };
  const handleChange = e => {
    var _a, _b, _c, _d;
    if (disableInternalHandleChange) return;
    checkOverflow === null || checkOverflow === void 0 ? void 0 : checkOverflow();
    const inputValueLength = ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) || 0;
    if (!characterLimit || Boolean(allowEntryOverCharacterLimit) || inputValueLength <= characterLimit ||
    // this last condition is to handle pasting text
    // and just letting the useEffect handling
    // truncating the string
    ((_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.selectionStart) > characterLimit) {
      setInputValue(handleTextSizeLimit((_d = e === null || e === void 0 ? void 0 : e.target) === null || _d === void 0 ? void 0 : _d.value));
      if ((0, _isFunction.isFunction)(onChange)) {
        onChange(e);
      }
    }
  };
  const handleFocus = e => {
    if ((0, _isFunction.isFunction)(onFocus)) {
      onFocus(e);
    }
  };
  const getHeadingEndDecorators = () => {
    var _a, _b;
    if (!characterLimit) {
      return decorators === null || decorators === void 0 ? void 0 : decorators.headingEnd;
    }
    return [localizedText && characterLimit && (/*#__PURE__*/_react.default.createElement(_CharacterCounter.CharacterCounter, Object.assign({}, otherCharacterCounterProps, {
      localizedText: localizedText,
      id: charCountDecoratorId,
      characterLimit: characterLimit,
      currentInputLength: disableInternalValueStateMgmt ? (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.length : (_b = inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString()) === null || _b === void 0 ? void 0 : _b.length
    }))), ..._react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.headingEnd)];
  };
  /** HandleComposition handles input that contains double-byte(JP,CN,KR, etc)
   * characters and standardizes them when the composition ends.  */
  const handleComposition = e => {
    e.target.value = (0, _normalizeDoubleByteToStandard.normalizeDoubleByteToStandard)(e.target.value, unicodeNormalizationForm);
    handleChange(e);
  };
  const renderInput = (0, _react.useCallback)(_a => {
    var _b;
    var {
        inputClassName,
        isFocused
      } = _a,
      attributes = __rest(_a, ["inputClassName", "isFocused"]);
    const inputClasses = classnames(inputClassName, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className);
    const getPlaceholderText = () => {
      if (placeholder && !readOnly && !disabled) {
        return placeholder;
      }
      return undefined;
    };
    const showOverflowTitle = inputType !== 'password' && hasOverflow && (!isFocused || readOnly || disabled);
    const overflowTitle = showOverflowTitle ? (disableInternalValueStateMgmt ? value : inputValue) || ((_b = internalInputRef.current) === null || _b === void 0 ? void 0 : _b.value) : undefined;
    return /*#__PURE__*/_react.default.createElement("input", Object.assign({
      title: overflowTitle === null || overflowTitle === void 0 ? void 0 : overflowTitle.toString()
    }, inputProps, attributes, {
      onKeyDown: (0, _chainFunction.default)(inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown, attributes === null || attributes === void 0 ? void 0 : attributes.onKeyDown),
      "aria-required": required,
      className: inputClasses,
      disabled: disabled,
      id: inputId,
      placeholder: getPlaceholderText(),
      readOnly: readOnly,
      ref: mergedInputRef,
      type: inputType,
      value: disableInternalValueStateMgmt ? value : inputValue,
      onBlur: handleBlur,
      onCompositionEnd: enableUnicodeNormalization ? (0, _chainFunction.default)(inputProps === null || inputProps === void 0 ? void 0 : inputProps.onCompositionEnd, handleComposition) : inputProps === null || inputProps === void 0 ? void 0 : inputProps.onCompositionEnd,
      onChange: handleChange,
      onFocus: handleFocus
    }));
  }, [inputProps, disabled, readOnly, placeholder, hasOverflow, inputValue, inputId]);
  let describedbyString;
  if (typeof inputDescribedby === 'string') {
    describedbyString = inputDescribedby;
  } else if (Array.isArray(inputDescribedby)) {
    describedbyString = (_a = inputDescribedby.join) === null || _a === void 0 ? void 0 : _a.call(inputDescribedby, ' ');
  }
  return /*#__PURE__*/_react.default.createElement(_FormField.FormField, Object.assign({}, otherProps, {
    inputDescribedby: characterLimit ? `${describedbyString || ''} ${charCountDecoratorId}`.trim() : describedbyString,
    type: inputType,
    decorators: Object.assign(Object.assign({}, decorators), {
      headingEnd: getHeadingEndDecorators()
    }),
    disabled: disabled,
    inputId: inputId,
    label: label,
    readOnly: readOnly,
    ref: ref,
    renderInput: renderInput,
    required: required,
    canTruncate: hasOverflow,
    noTruncationOnFocus: true
  }));
});
InputField.displayName = 'InputField';
var _default = exports.default = InputField;